import { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  variant?: "primary" | "success" | "info" | "medical" | "warning";
  size?: "sm" | "md" | "lg";
  className?: string;
}

export default function Badge({
  children,
  variant = "primary",
  size = "md",
  className = "",
}: BadgeProps) {
  const baseClasses =
    "inline-flex items-center rounded-full font-medium transition-all duration-200";

  const variants = {
    primary:
      "bg-gradient-to-r from-primary-100 to-primary-50 text-primary-700 dark:from-primary-900/40 dark:to-primary-800/30 dark:text-primary-300 border border-primary-200/60 dark:border-primary-700/40 shadow-[0_0_8px_rgba(79,70,229,0.08)] dark:shadow-[0_0_8px_rgba(129,140,248,0.1)]",
    success:
      "bg-gradient-to-r from-emerald-100 to-green-50 text-emerald-700 dark:from-emerald-900/40 dark:to-green-800/30 dark:text-emerald-300 border border-emerald-200/60 dark:border-emerald-700/40 shadow-[0_0_8px_rgba(16,185,129,0.08)]",
    info: "bg-gradient-to-r from-sky-100 to-blue-50 text-sky-700 dark:from-sky-900/40 dark:to-blue-800/30 dark:text-sky-300 border border-sky-200/60 dark:border-sky-700/40 shadow-[0_0_8px_rgba(14,165,233,0.08)]",
    medical:
      "bg-gradient-to-r from-sky-100 via-teal-50 to-emerald-50 text-teal-700 dark:from-sky-900/30 dark:via-teal-900/30 dark:to-emerald-900/30 dark:text-teal-300 border border-teal-200/60 dark:border-teal-700/40 shadow-[0_0_8px_rgba(13,148,136,0.08)]",
    warning:
      "bg-gradient-to-r from-orange-100 to-amber-50 text-orange-700 dark:from-orange-900/40 dark:to-amber-800/30 dark:text-orange-300 border border-orange-200/60 dark:border-orange-700/40 shadow-[0_0_8px_rgba(249,115,22,0.08)]",
  };

  const sizes = {
    sm: "px-2.5 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
    lg: "px-4 py-1.5 text-base",
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  return <span className={classes}>{children}</span>;
}
